import api from './index';

export const searchGlobal = async (query) => {
  try {
    const response = await api.get(`/global/search/?search=${query}`);
    return response.data;
  } catch (error) {
    console.error("Error during global search:", error);
    throw error;
  }
};